
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_493_1027)"}},[_c('path',{attrs:{"d":"M10 0C4.477 0 0 4.48 0 10.006c0 5.525 4.477 10.006 10 10.006s10-4.48 10-10.006S15.523 0 10 0zm3.415 6.4a.173.173 0 01-.173.173h-2.434v1.31h2.434c.095 0 .173.077.173.172v2.436a.173.173 0 01-.173.173H10.98v5.344a.173.173 0 01-.173.173h-2.3a.173.173 0 01-.174-.173v-5.344H6.758a.173.173 0 01-.173-.173V8.056c0-.096.077-.173.173-.173h1.576v-.988c0-.014.002-.028.005-.04.001-1.408.302-3.017 2.605-3.024h2.298c.095 0 .173.077.173.172V6.4z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_493_1027"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    